(function () {
  if (window.__preaHeaderInitialized) return;
  window.__preaHeaderInitialized = true;

  var currentScript = document.currentScript || document.querySelector('script[data-prea-header]');
  var config = currentScript ? currentScript.dataset : {};

  var cartIntentSelector = '#cart-icon-bubble, #floating-cart-icon, .quick-add, .quick-add__submit, product-form, [data-prea-card-add]';
  var cartOpenSelector = '#cart-icon-bubble, #floating-cart-icon';

  function styleConfig(href, id) {
    return href ? { href: href, id: id } : null;
  }

  function compactStyles(styles) {
    return styles.filter(function (style) {
      return style && style.href;
    });
  }

  function loadStyle(href, id) {
    if (!href) return;

    if (window.__preaLoadStyle) {
      window.__preaLoadStyle(href, id);
      return;
    }

    if ((id && document.getElementById(id)) || document.querySelector('link[href="' + href + '"]')) return;

    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    if (id) link.id = id;
    document.head.appendChild(link);
  }

  function loadStyles(styles) {
    if (window.__preaLoadStyles) {
      window.__preaLoadStyles(styles);
      return;
    }

    styles.forEach(function (style) {
      loadStyle(style.href, style.id);
    });
  }

  function loadScript(src, id) {
    if (window.__preaLoadScript) return window.__preaLoadScript(src, id);
    if (!src) return Promise.resolve();

    var existing = (id && document.getElementById(id)) || document.querySelector('script[src="' + src + '"]');
    if (existing) {
      if (existing.dataset.preaLoaded === 'true') return Promise.resolve();

      return new Promise(function (resolve, reject) {
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
      });
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      if (id) script.id = id;
      script.onload = function () {
        script.dataset.preaLoaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function lazyStylesOnIntent(selector, styles) {
    if (window.__preaLazyStylesOnIntent) return window.__preaLazyStylesOnIntent(selector, styles);

    var loaded = false;

    function load() {
      if (loaded) return;
      loaded = true;
      loadStyles(styles);
    }

    function onIntent(event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest(selector)) return;
      load();
    }

    document.addEventListener('pointerdown', onIntent, { capture: true, passive: true });
    document.addEventListener('focusin', onIntent, { capture: true });
    document.addEventListener('mouseover', onIntent, { capture: true, passive: true });

    return load;
  }

  var menuDrawerStyles = compactStyles([
    styleConfig(config.menuDrawerCss, 'prea-menu-drawer-css')
  ]);

  var cartDrawerStyles = compactStyles([
    styleConfig(config.cartDrawerCss, 'prea-cart-drawer-css'),
    styleConfig(config.cartCss, 'prea-cart-css'),
    styleConfig(config.cartItemsCss, 'prea-cart-items-css'),
    styleConfig(config.cartTotalsCss, 'prea-cart-totals-css'),
    styleConfig(config.cartPriceCss, 'prea-cart-price-css'),
    styleConfig(config.cartDiscountsCss, 'prea-cart-discounts-css'),
    styleConfig(config.cartLoadingCss, 'prea-cart-loading-css')
  ]);

  lazyStylesOnIntent('#Details-menu-drawer-container, #Details-menu-drawer-container summary, #menu-drawer', menuDrawerStyles);

  window.__preaCartDrawerStyles = window.__preaCartDrawerStyles || cartDrawerStyles;
  window.__preaLoadCartDrawerStyles = window.__preaLoadCartDrawerStyles || function () {
    loadStyles(window.__preaCartDrawerStyles);
  };

  if (config.cartDrawerEnabled === 'true') {
    window.__preaLoadCartDrawerScript = window.__preaLoadCartDrawerScript || function () {
      window.__preaLoadCartDrawerStyles();
      if (customElements.get('cart-drawer')) return Promise.resolve();

      return loadScript(config.cartJs, 'prea-cart-js')
        .then(function () {
          return loadScript(config.cartCustomPreviewJs, 'prea-cart-custom-preview-js');
        })
        .then(function () {
          return loadScript(config.cartDrawerJs, 'prea-cart-drawer-js');
        })
        .then(function () {
          return loadScript(config.cartDrawerLoadingJs, 'prea-cart-drawer-loading-js');
        })
        .then(function () {
          return loadScript(config.cartDrawerDiscountJs, 'prea-cart-drawer-discount-js');
        });
    };
  }

  lazyStylesOnIntent(cartIntentSelector, window.__preaCartDrawerStyles);

  function loadCartDrawer() {
    if (typeof window.__preaLoadCartDrawerScript !== 'function') return Promise.resolve();
    return window.__preaLoadCartDrawerScript();
  }

  if (config.cartDrawerEnabled === 'true') {
    document.addEventListener('pointerover', function (event) {
      if (!event.target.closest || !event.target.closest(cartIntentSelector)) return;
      loadCartDrawer();
    }, { capture: true, passive: true });

    document.addEventListener('focusin', function (event) {
      if (!event.target.closest || !event.target.closest(cartIntentSelector)) return;
      loadCartDrawer();
    }, { capture: true });

    document.addEventListener('click', function (event) {
      if (!event.target.closest) return;

      var cartLink = event.target.closest(cartOpenSelector);
      if (!cartLink || customElements.get('cart-drawer')) return;

      event.preventDefault();
      loadCartDrawer().then(function () {
        var cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(cartLink);
          return;
        }

        window.location.href = cartLink.href;
      });
    }, { capture: true });
  }

  function initSearchState() {
    document.querySelectorAll('.header__icons').forEach(function (icons) {
      if (icons.dataset.preaSearchStateBound === 'true') return;

      var searchDetails = icons.querySelector('.header__search details');
      if (!searchDetails) return;

      var syncSearchState = function () {
        icons.classList.toggle('header__icons--search-open', searchDetails.hasAttribute('open'));
      };

      icons.dataset.preaSearchStateBound = 'true';
      searchDetails.addEventListener('toggle', syncSearchState);
      syncSearchState();
    });
  }

  var predictiveSearchLoading = false;
  var predictiveSearchCssLoaded = false;

  function loadPredictiveSearchCss() {
    if (predictiveSearchCssLoaded) return;

    predictiveSearchCssLoaded = true;
    loadStyle(config.predictiveSearchCss, 'prea-predictive-search-css');
  }

  function loadPredictiveSearch() {
    if (predictiveSearchLoading || customElements.get('predictive-search')) return;

    loadPredictiveSearchCss();
    predictiveSearchLoading = true;
    loadScript(config.predictiveSearchJs, 'prea-predictive-search-js')
      .then(function () {
        predictiveSearchLoading = false;
      })
      .catch(function () {
        predictiveSearchLoading = false;
      });
  }

  function initPredictiveSearch() {
    if (config.predictiveSearchEnabled !== 'true') return;

    document.querySelectorAll('.header__icons .header__search').forEach(function (searchRoot) {
      if (searchRoot.dataset.preaPredictiveSearchBound === 'true') return;

      searchRoot.dataset.preaPredictiveSearchBound = 'true';
      searchRoot.addEventListener('pointerdown', loadPredictiveSearch, { once: true, capture: true });
      searchRoot.addEventListener('focusin', loadPredictiveSearch, { once: true, capture: true });
      searchRoot.addEventListener('input', loadPredictiveSearch, { once: true, capture: true });
    });
  }

  function initHeader() {
    initSearchState();
    initPredictiveSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeader, { once: true });
  } else {
    initHeader();
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.scrollFrame = null;

        this.onScrollHandler = () => {
          if (this.scrollFrame) return;

          this.scrollFrame = window.requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.onScroll();
          });
        };
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        const announcement = document.querySelector('.announcement-bar-section');
        const announcementHeight = announcement ? announcement.offsetHeight : 0;
        const headerHeight = this.header.offsetHeight;

        document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDelta = scrollTop - this.currentScrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) {
          this.currentScrollTop = scrollTop;
          return;
        }

        if (Math.abs(scrollDelta) < 3 && scrollTop > this.headerBounds.top) return;

        if (scrollDelta > 0 && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          this.hide();
        } else if (scrollDelta < 0 && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            this.reveal();
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            this.hide();
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          this.reset();
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        if (this.searchModal && typeof this.searchModal.close === 'function') {
          this.searchModal.close(false);
        }
      }
    });
  }
})();
